import React from 'react';
import Hero from './components/imp-email/Hero';
import Main from './components/imp-email/Main';

const ImpEmails = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ImpEmails;